import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CareersListComponent } from './careers-list.component';
import { ConfirmRemovalComponent } from './confirm-removal.component';

import { SharedModule } from '../shared/shared.module';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [
    SharedModule,
    NgbDatepickerModule,
    RouterModule.forChild([

    ]),
  ],
  declarations: [
    CareersListComponent, ConfirmRemovalComponent
  ],
  exports: [CareersListComponent, NgbDatepickerModule],
  providers: [],
  entryComponents: [ConfirmRemovalComponent],
  bootstrap: []
})
export class CareersModule { }
